import ModuleUnavailablePage from "../../../../components/Admin/InvestorPortal/ModuleUnavailablePage";
import { withInvestorPortalGuard } from "../withInvestorPortalGuard";

function InvestorAccountDetailPage() {
  return <ModuleUnavailablePage moduleName="Investor account details" />;
}

export default withInvestorPortalGuard(InvestorAccountDetailPage, "investorPortal");
